var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AuthApiQuery } from '../../../infra/api';
var TimesheetQuery = /** @class */ (function (_super) {
    __extends(TimesheetQuery, _super);
    function TimesheetQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.meta = {
            cacheTime: 60 * 60 * 1000,
        };
        return _this;
    }
    TimesheetQuery.prototype.getKey = function (payload) {
        return ['timesheet', payload.ownerType, payload.ownerId, payload.date];
    };
    TimesheetQuery.prototype.request = function (payload) {
        var options = this.buildOptions();
        return this.http
            .get("/v1/".concat(payload.ownerType, "/").concat(payload.ownerId, "/timesheet/").concat(payload.date), options)
            .then(function (result) { return result[0]; });
    };
    return TimesheetQuery;
}(AuthApiQuery));
export { TimesheetQuery };
